import store from "../../store/store";
export const componentKey = "PATIENT_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    getSearchedPatientList: (state, action) => {
      state.searchedPatientList = action.payload;
    },
    // Append next page of search results (infinite scroll). Deduped by id/bsaId
    // so a non-paginating backend can't produce duplicate rows.
    appendSearchedPatientList: (state, action) => {
      const existing = state.searchedPatientList ?? [];
      const incoming = action.payload ?? [];
      const seen = new Set(existing.map((p) => p?.id ?? p?.bsaId));
      const fresh = incoming.filter((p) => !seen.has(p?.id ?? p?.bsaId));
      state.searchedPatientList = [...existing, ...fresh];
    },
    // Total pages for the participant search (drives infinite-scroll has-more).
    setSearchedPatientTotalPages: (state, action) => {
      state.searchedPatientTotalPages = action.payload;
    },
    setCloseCreatePatientDrawer: (state, action) => {
      state.closeCreatePatientDrawer = action.payload;
    },
    getPatientListData: (state, action) => {
      state.patientListData = action.payload;
    },
    getClinicLocationData: (state, action) => {
      state.clinicLocations = action.payload;
    },
    getViewPatientProfileData: (state, action) => {
      state.viewPatientProfileData = action.payload;
    },
    setCloseEditProfileDialog: (state, action) => {
      state.closeEditProfileDialog = action.payload;
    },
    setCloseCreateVisitDrawer: (state, action) => {
      state.closeCreateVisitDrawer = action.payload;
    },

    setCreateVisitDataForTriage: (state, action) => {
      state.createVisitDataFormTriage = action.payload;
    },
    setCloseCreateTriageDrawer: (state, action) => {
      state.closeTriageDrawer = action.payload;
    },
    setTableDataForVisitTab: (state, action) => {
      state.tableDataForVisitTab = action.payload;
    },
    setTableDataForOrderTab: (state, action) => {
      state.tableDataForOrderTab = action.payload;
    },

    setVisitNoteCareFlowData: (state, action) => {
      state.visitNoteCareFlowData = action.payload;
    },
    setDataForEmergencyContactTab: (state, action) => {
      state.dataForEmergencyContact = action.payload;
    },
    setCloseEmergencyContactDialog: (state, action) => {
      state.closeEmergencyContactDialog = action.payload;
    },
    setCloseBaseCampDialog: (state, action) => {
      state.closeBaseCampDialog = action.payload;
    },
    setCloseChiefComplaintDialog: (state, action) => {
      state.closeChiefComplaintDialog = action.payload;
    },
    setMasterCodeData: (state, action) => {
      state.masterCodes = action.payload;
    },

    setDataToDischargeForm: (state, action) => {
      state.dataOfDischargeForm = action.payload;
    },
    setUpdateVisitNoteDataOnceDraftNote: (state, action) => {
      state.updateVisitNoteDataOnceDraftNote = action.payload;
    },
    setOpenCreateVisitForceFullyDialog: (state, action) => {
      state.openCreateVisitForceFullyDialog = action.payload;
    },
    setCloseCreateOrderDialog: (state, action) => {
      state.closeCreateOrderDialog = action.payload;
    },
    setVisitPreviewDialog: (state, action) => {
      state.openVisitPreviewDialog = action.payload;
    },
    setCloseDispositionDialog: (state, action) => {
      state.closeDispositionDialog = action.payload;
    },
    setDepartmentData: (state, action) => {
      state.departmentData = action.payload;
    },
    setDispositionData: (state, action) => {
      state.dispositionData = action.payload;
    },
    setFacilityData: (state, action) => {
      state.facilityData = action.payload;
    },
    setRoomList: (state, action) => {
      state.roomList = action.payload;
    },
    setIncidentLocationData: (state, action) => {
      state.incidentLocationData = action.payload;
    },
    setNotesData: (state, action) => {
      state.notesData = action.payload;
    },
    setOrderChange: (state, action) => {
      state.isOrderChange = action.payload;
    },
    setCloseVerifyOrderStatus: (state, action) => {
      state.closeVerifyOrderStatus = action.payload;
    },
    setRefreshPatientList: (state, action) => {
      state.refreshPatientList = action.payload;
    },
    setPatientIdFromParticipant: (state, action) => {
      state.patientIdFromParticipant = action.payload;
    },
    setCloseEMSSceneVisit: (state, action) => {
      state.closeEMSSceneVisit = action.payload;
    },
    setTempVisitData: (state, action) => {
      state.tempVisitData = action.payload;
    },
    setFacilityList: (state, action) => {
      state.facilityList = action.payload;
    },
    setVisitNoteCareFlowDataForDischargePreview: (state, action) => {
      state.visitNoteCareFlowDataForDischargePreview = action.payload;
    },
    setBundleOrderData: (state, action) => {
      state.bundleOrderData = action.payload;
    },
    setOrderNotes: (state, action) => {
      state.orderNotes = action.payload;
    },
    setCloseViewNotesDialog: (state, action) => {
      state.closeViewNotesDialog = action.payload;
    },
    setTableDataForDocumentsTab: (state, action) => {
      state.tableDataForDocumentsTab = action.payload;
    },
    setCloseUploadDocumentDialog: (state, action) => {
      state.closeUploadDocumentDialog = action.payload;
    },
  },
  initialReducerState: {
    isLoggedIn: false,
    searchedPatientTotalPages: 1,
    clinicLocations: [],
    viewPatientProfileData: {},
    closeEditProfileDialog: false,
    closeCreatePatientDrawer: false,
    closeCreateVisitDrawer: false,
    createVisitDataFormTriage: {},
    closeTriageDrawer: false,
    tableDataForVisitTab: [],
    tableDataForOrderTab: {},
    visitNoteCareFlowData: {},
    dataForEmergencyContact: {},
    closeEmergencyContactDialog: false,
    closeBaseCampDialog: false,
    closeChiefComplaintDialog: false,
    masterCodes: {},
    dataOfDischargeForm: {},
    updateVisitNoteDataOnceDraftNote: false,
    openCreateVisitForceFullyDialog: false,
    closeCreateOrderDialog: false,
    openVisitPreviewDialog: false,
    closeDispositionDialog: false,
    departmentData: [],
    dispositionData: {},
    facilityData: [],
    roomList: [],
    incidentLocationData: [],
    notesData: {},
    isOrderChange: false,
    closeVerifyOrderStatus: false,
    refreshPatientList: false,
    patientIdFromParticipant: "",
    closeEMSSceneVisit: false,
    tempVisitData: {},
    facilityList: {},
    visitNoteCareFlowDataForDischargePreview: {},
    bundleOrderData: null,
    orderNotes: [],
    closeViewNotesDialog: false,
    tableDataForDocumentsTab: {},
    closeUploadDocumentDialog: false,
  },
});

export const {
  setIsLoggedIn,
  getSearchedPatientList,
  appendSearchedPatientList,
  setSearchedPatientTotalPages,
  setCloseCreatePatientDrawer,
  getPatientListData,
  getClinicLocationData,
  getViewPatientProfileData,
  setCloseEditProfileDialog,
  setCloseCreateVisitDrawer,
  setCreateVisitDataForTriage,
  setCloseCreateTriageDrawer,
  setTableDataForVisitTab,
  setTableDataForOrderTab,
  setVisitNoteCareFlowData,
  setDataForEmergencyContactTab,
  setCloseEmergencyContactDialog,
  setCloseBaseCampDialog,
  setCloseChiefComplaintDialog,
  setMasterCodeData,
  setDataToDischargeForm,
  setUpdateVisitNoteDataOnceDraftNote,
  setOpenCreateVisitForceFullyDialog,
  setCloseCreateOrderDialog,
  setVisitPreviewDialog,
  setCloseDispositionDialog,
  setDepartmentData,
  setDispositionData,
  setFacilityData,
  setRoomList,
  setIncidentLocationData,
  setNotesData,
  setOrderChange,
  setCloseVerifyOrderStatus,
  setRefreshPatientList,
  setPatientIdFromParticipant,
  setCloseEMSSceneVisit,
  setTempVisitData,
  setFacilityList,
  setVisitNoteCareFlowDataForDischargePreview,
  setBundleOrderData,
  setOrderNotes,
  setCloseViewNotesDialog,
  setTableDataForDocumentsTab,
  setCloseUploadDocumentDialog,
} = actions;
